'use client';

import { Button } from '@ui/components/button';
import { text } from '@modules/garden-planner/text';
import { FaIcon } from '@micks-yard/icons/FaIcon';
import { faCheck } from '@micks-yard/icons/solid/faCheck';
import { faLink } from '@micks-yard/icons/solid/faLink';

interface ShareButtonViewProps {
  copySuccess: boolean;
  onShareCopy: () => void;
}

export function ShareButtonView({ copySuccess, onShareCopy }: ShareButtonViewProps) {
  return (
    <Button
      type="button"
      className="w-full justify-start gap-2 bg-emerald-600 text-white hover:bg-emerald-700"
      onClick={onShareCopy}>
      {copySuccess ? (
        <FaIcon icon={faCheck} className="size-4" />
      ) : (
        <FaIcon icon={faLink} className="size-4" />
      )}
      {copySuccess ? text.linkCopied : text.shareGarden}
    </Button>
  );
}
